import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authActions, authSelectors } from '../redux/authSlice'
import { userActions } from '../redux/userSlice'
import notification from '../components/Notification/notification'
import { syncCartWithBackend } from '../pages/Cart/cartApi'
import { UserTypes } from '../util/constants'

const useAuthForm = (redirect, login = false) => {
    const dispatch = useDispatch()

    const isFetching = useSelector(authSelectors.getIsFetchingState)
    const hasError = useSelector(authSelectors.getHasErrorState)
    const errorMessage = useSelector(authSelectors.getErrorMessageState)
    const response = useSelector(authSelectors.getResponseDataStatus)
    const success = useSelector(authSelectors.getSuccessState)
    const userType = response && response.accountcategory
    const loader = useRef()

    useEffect(() => {
        if (isFetching) {
            notification
                .loading({
                    title: 'Submitting',
                    duration: 0,
                })
                .then(res => {
                    loader.current = res[0]
                })
        }

        if (hasError) {
            loader.current && loader.current()
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }

        if (success) {
            loader.current && loader.current()
            //Do something with response if you expect (eg login and getting the user's data)
            let hasPlan
            if (login) {
                hasPlan = !!response.accounttype
                dispatch(
                    userActions.login({
                        userDetails: { ...response, userType },
                    })
                )
            }
            if (userType === UserTypes.Beneficiary) {
                dispatch(authActions.resetState())
                redirect(hasPlan, response.accountcategory)
            } else {
                dispatch(syncCartWithBackend()).then(() => {
                    dispatch(authActions.resetState())
                    redirect(hasPlan)
                })
            }
        }
    }, [isFetching, success, hasError])

    useEffect(() => {
        return () => dispatch(authActions.resetState())
    }, [dispatch])
}

export default useAuthForm
